import { TPLClassify } from "../types";

export enum LibCategory {
  INSTALLED = 1,
  UN_INSTALLED = 2,
  ALL = 3,
}
export enum TagCategory {
  ALL = 0,
  UML = 1,
  UI = 2,
  SYS_DESIGN = 3,
  ICON = 4
}

export enum FileCategory {
  rough = 1,
  label = 2,
  fabra = 3
}

export enum Classification {
  common_all = 0,
  recommended = 1,

  label_all = 200,
  temu_label = 201, // TEMU标签
  shein_label = 202, // SHEIN标签
  tiktok_label = 203, // TIKTOK标签
  aliExpress_label = 204, // ALIEXPRESS标签
  amazon_label = 205, // AMAZON标签

  other = 1,
  cross_border = 2,
  clothes = 3, // 服饰
  shoeBag = 4, //鞋包
  food = 5, // 食品
  // jewelry = 6, // 珠宝
  baby = 7, // 母婴

  ecommerce_all = 100, // 电商
  ecommerce_main_image_1_1 = 101,
  ecommerce_main_image_3_4 = 102,
  ecommerce_main_image_border = 103,
  ecommerce_detail_page = 104,
  ecommerce_live_chat = 105, // 电商直播
  ecommerce_main_image_watermark = 106, // 电商主图水印

  cross_border_all = 300, // 跨境
  cross_border_main_image_1_1 = 301, // 跨境主图(1:1)
  cross_border_main_image_3_4 = 302, // 跨境主图(3:4)
}

export enum CollectionType {
  library = 1,
  template = 2
}

export enum ActionType {
  own = 1,
  like = 2,
  install = 3
}

export enum StatusType {
  private = 1,
  public = 2
}

export enum SharedUrlStatus {
  active = 1,
  noActive = 2
}

export enum Permission {
  view = 0,
  edit = 1
}

export enum AccessLevel {
  ALL = 1,
  INNER = 2,
  SPECIFY = 3,
  ONLY_SELF = 4,
}

export enum AccountProvider {
  NONE = 0,
  PHONE = 1,
  EMAIL = 2,
  WECHAT = 3,
  QQ = 4
}

export enum AllowSaveToCloud {
  noAllow = 0,
  allow = 1
}

export interface CategoryItem {
  text: string;
  i18nKey?: string;
  classify: Classification;
  children?: CategoryItem[];
}

export const LabelChanel = [
  {
    text: 'TEMU标签',
    i18nKey: 'shared.classification.temu_label',
    classify: Classification.temu_label
  },
  {
    text: 'SHEIN标签',
    i18nKey: 'shared.classification.shein_label',
    classify: Classification.shein_label
  },
  {
    text: 'TIKTOK标签',
    i18nKey: 'shared.classification.tiktok_label',
    classify: Classification.tiktok_label
  },
  {
    text: 'ALIEXPRESS标签',
    i18nKey: 'shared.classification.aliExpress_label',
    classify: Classification.aliExpress_label
  },
  {
    text: 'AMAZON标签',
    i18nKey: 'shared.classification.amazon_label',
    classify: Classification.amazon_label
  },
  {
    text: '其它标签',
    i18nKey: 'shared.classification.other',
    classify: Classification.other
  },
]

export const EcommerceChanel = [
  // {
  //   text: '全部',
  //   classify: Classification.common_all
  // },
  {
    text: '电商主图(1:1)',
    i18nKey: 'shared.classification.ecommerce_main_image_1_1',
    classify: Classification.ecommerce_main_image_1_1
  },
  {
    text: '电商主图(3:4)',
    i18nKey: 'shared.classification.ecommerce_main_image_3_4',
    classify: Classification.ecommerce_main_image_3_4
  },
  {
    text: '主图水印',
    i18nKey: 'shared.classification.ecommerce_main_image_watermark',
    classify: Classification.ecommerce_main_image_watermark
  },
  {
    text: '电商主图边框',
    i18nKey: 'shared.classification.ecommerce_main_image_border',
    classify: Classification.ecommerce_main_image_border
  },
  {
    text: '电商直播',
    i18nKey: 'shared.classification.ecommerce_live_chat',
    classify: Classification.ecommerce_live_chat
  },
]


export const CrossBorderChanel = [
  {
    text: '跨境主图(1:1)',
    i18nKey: 'shared.classification.cross_border_main_image_1_1',
    classify: Classification.cross_border_main_image_1_1
  },
  {
    text: '跨境主图(3:4)',
    i18nKey: 'shared.classification.cross_border_main_image_3_4',
    classify: Classification.cross_border_main_image_3_4
  },
]

export const AllChanel = [...EcommerceChanel, ...CrossBorderChanel, ...LabelChanel]



export const TwoLevelCategoryList: CategoryItem[] = [
  {
    text: '全部',
    i18nKey: 'shared.classification.common_all',
    classify: Classification.common_all,
    children: [
      ...LabelChanel.filter(item => item.classify !== Classification.common_all),
      ...EcommerceChanel.filter(item => item.classify !== Classification.common_all),
      ...CrossBorderChanel.filter(item => item.classify !== Classification.common_all)
    ]
  },
  {
    text: '电商',
    i18nKey: 'shared.classification.ecommerce_all',
    classify: Classification.ecommerce_all, // 一级分类使用all作为占位
    children: EcommerceChanel
  },
  {
    text: '标签',
    i18nKey: 'shared.classification.label_all',
    classify: Classification.label_all, // 一级分类使用all作为占位
    children: LabelChanel
  },
  {
    text: '跨境',
    i18nKey: 'shared.classification.cross_border_all',
    classify: Classification.cross_border_all, // 一级分类使用all作为占位
    children: CrossBorderChanel
  }
];


export enum MaterialType {
  material = 'material',
  picture = 'picture',
  background = 'background',
  ai_picture = 'ai_picture',
  ai_model = 'ai_model'
}

// Label
export const __THUMB_PREFIX__ = '__label_thumb__'
export const __TEMPLATE_PREFIX__ = '__label_templates__'
export const __LABEL_FILE_PREFIX__ = '__label_file__'

// fabra editor Image
export const __FABRA_MATERIAL__ = '__fabra_material__'
export const __FABRA_TEXT__ = '__fabra_text__'
export const __FABRA_FILE__ = '__fabra_file__'

export const __AVATAR__ = '__avatar__'
export const __FEEDBACK_PREFIX__ = '__feedback__'
